export const coreActivities = [
  {
    id: 1,
    title: 'Software Development:',
    text: 'Our focus is on coding software applications for web, mobile, and desktop platforms, including frontend (User Interface) and backend (Server work) development.',
    iconKey: 'software',
  },
  {
    id: 2,
    title: 'Requirement Analysis:',
    text: 'Understanding client needs involves gathering requirements, defining project scopes, and creating detailed software specifications through close collaboration.',
    iconKey: 'metrics',
  },
  {
    id: 3,
    title: 'Design & Architecture:',
    text: 'After establishing requirements, developers design the architecture and user interface, crafting wireframes, mockups, and defining software structure.',
    iconKey: 'design',
  },
  {
    id: 4,
    title: 'Coding & Development:',
    text: "Once requirements are set, developers implement the application's architecture and user interface, creating wireframes, mockups, and defining software structure.",
    iconKey: 'code',
  },
  {
    id: 5,
    title: 'Quality and Assurance:',
    text: 'Our Quality and Assurance professionals test software, identifying and fixing bugs, ensuring it meets client requirements and performs as expected.',
    iconKey: 'quality',
  },
  {
    id: 6,
    title: 'Project Management:',
    text: 'We specialize in a diverse range of activities, including custom software development, system integration, and robust IT solutions to optimize business processes and enhance overall efficiency.',
    iconKey: 'project',
  },
];
